module.exports = __webpack_public_path__ + "static/media/270917.c8b5fdbe.png";